/* eslint-disable max-lines-per-function */
import React from 'react';
import { Table } from 'semantic-ui-react';
import range from 'lodash/range';
import {
    Header, renderPrice, Title, colors, filterObject
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    }
};

const Table1 = ({ data, matrixType }) => (
    <Table celled compact>
        <Table.Header>
            <Table.Row>
                <Header colSpan='100' content='Building 01' />
            </Table.Row>
            <Table.Row>
                {['Apt#', '01', '03', '05', '07', '09', '11', '15', '17', '19', '21'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['', 'Pool', '', '', 'Pool', '', '', '', 'Pool', '', 'Pool'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Type', '2/1 C', '1/1 A', '1/1 A', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '1/1 A', '1/1 A', '2/2 C'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Sq Ft', '995', '845', '845', '1085', '1085', '1085', '1085', '845', '845', '1014'].map(content => <Header content={content} />)}
            </Table.Row>

        </Table.Header>

        <Table.Body>
            {/* 8th and 7th floor */}
            {range(8, 0, -1)
                .map(n => n.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                }))
                .map(floor => (
                    <Table.Row key={floor}>
                        <Table.Cell content={floor} textAlign='center' />
                        {['01', '03', '05', '07', '09', '11', '15', '17', '19', '21'].map(unit => (
                            <Table.Cell
                                style={{ backgroundColor: colors[data[`01-${floor}${unit}`].status] }}
                                content={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                textAlign='center'
                            />
                        ))}
                    </Table.Row>
                ))}

        </Table.Body>
    </Table>
);

const Table2 = ({ data, matrixType }) => (
    <Table celled compact>
        <Table.Header>
            <Table.Row>
                <Header colSpan='100' content='North / Parking Lot View' />
            </Table.Row>
            <Table.Row>
                {['Apt#', '02', '04', '06', '08', '10', '12', '14', '16'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['', 'MIA', '', '', 'MIA', '', '', '', 'MIA'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Type', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Sq Ft', '1085', '1085', '1085', '1085', '1085', '1085', '1085', '1085'].map(content => <Header content={content} />)}
            </Table.Row>

        </Table.Header>

        <Table.Body>
            {/* 8th and 7th floor */}
            {range(8, 0, -1)
                .map(n => n.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                }))
                .map(floor => (
                    <Table.Row key={floor}>
                        <Table.Cell content={floor} textAlign='center' />
                        {['02', '04', '06', '08', '10', '12', '14', '16'].map(unit => (
                            <Table.Cell style={{ backgroundColor: colors[data[`01-${floor}${unit}`].status] }} content={renderPrice(data[`01-${floor}${unit}`], matrixType)} textAlign='center'/>
                        ))}
                    </Table.Row>
                ))}

        </Table.Body>
    </Table>

);

const Table3 = ({ data, matrixType }) => (
    <Table celled compact>
        <Table.Header>
            <Table.Row>
                <Header colSpan='100' content='Building 02' />
            </Table.Row>
            <Table.Row>
                {['Apt#', '01', '03', '05', '07', '09', '11', '15', '17', '19', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['', 'gate', '', '', '', '', '', '', '', 'courtyard', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Type', '3/2 E', '2/2 D', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '1/1 A', '2/1 C', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Sq Ft', '1426', '1287', '1085', '1085', '1085', '1085', '1085', '845', '995', ''].map(content => <Header content={content} />)}
            </Table.Row>

        </Table.Header>

        <Table.Body>
            {/* 8th and 7th floor */}
            {range(9, 7, -1)
                .map(n => n.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                }))
                .map(floor => (
                    <Table.Row key={floor}>
                        <Table.Cell content={floor} textAlign='center' />
                        {['01', '03', '05', '07', '09', '11', '15', '17', '19'].map(unit => (
                            <Table.Cell style={{ backgroundColor: colors[data[`02-${floor}${unit}`].status] }} content={renderPrice(data[`02-${floor}${unit}`], matrixType)} textAlign='center'/>
                        ))}
                    </Table.Row>
                ))
            }
            <Table.Row>
                {['Apt#', '01', '03', '05', '07', '09', '11', '15', '17', '19', '21'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Type', '2/2 C', '1/1 A', '1/1 A', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '1/1 A', '2/1 C'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Sq Ft', '1014', '845', '845', '1085', '1085', '1085', '1085', '1085', '845', '995'].map(content => <Header content={content} />)}
            </Table.Row>

            {range(7, 0, -1)
                .map(n => n.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                }))
                .map(floor => (
                    <Table.Row key={floor}>
                        <Table.Cell content={floor} textAlign='center' />
                        {['01', '03', '05', '07', '09', '11', '15', '17', '19', '21'].map(unit => (
                            <Table.Cell style={{ backgroundColor: colors[data[`02-${floor}${unit}`].status] }} content={renderPrice(data[`02-${floor}${unit}`], matrixType)} textAlign='center'/>
                        ))}
                    </Table.Row>
                ))
            }

        </Table.Body>
    </Table>
);


const Table4 = ({ data, matrixType }) => (
    <Table celled compact>
        <Table.Header>
            <Table.Row>
                <Header colSpan='100' content='East / Parking Lot View' />
            </Table.Row>
            <Table.Row>
                {['Apt#', '02', '04', '06', '08', '10', '12', '14', '16', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['', 'Parking', 'City', '', '', '', 'City', '', '', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Type', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 D', '3/2 E', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Sq Ft', '1085', '1085', '1085', '1085', '1085', '1085', '1287', '1426', ''].map(content => <Header content={content} />)}
            </Table.Row>

        </Table.Header>

        <Table.Body>
            {/* 8th and 7th floor */}
            {range(9, 7, -1)
                .map(n => n.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                }))
                .map(floor => (
                    <Table.Row key={floor}>
                        <Table.Cell content={floor} textAlign='center' />
                        {['02', '04', '06', '08', '10', '12', '14', '16'].map(unit => (
                            <Table.Cell style={{ backgroundColor: colors[data[`02-${floor}${unit}`].status] }} content={renderPrice(data[`02-${floor}${unit}`], matrixType)} textAlign='center'/>
                        ))}
                    </Table.Row>
                ))
            }
            <Table.Row>
                {['Apt#', '02', '04', '06', '08', '10', '12', '14', '16', '18'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Type', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '1/1 A', '1/1 A', '2/2 C'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Sq Ft', '1085', '1085', '1085', '1085', '1085', '1085', '845', '845', '1014'].map(content => <Header content={content} />)}
            </Table.Row>

            {range(7, 0, -1)
                .map(n => n.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                }))
                .map(floor => (
                    <Table.Row key={floor}>
                        <Table.Cell content={floor} textAlign='center' />
                        {['02', '04', '06', '08', '10', '12', '14', '16', '18'].map(unit => (
                            <Table.Cell style={{ backgroundColor: colors[data[`02-${floor}${unit}`].status] }} content={renderPrice(data[`02-${floor}${unit}`], matrixType)} textAlign='center'/>
                        ))}
                    </Table.Row>
                ))
            }

        </Table.Body>
    </Table>
);

const Table5 = ({ data, matrixType }) => (
    <Table celled compact>
        <Table.Header>
            <Table.Row>
                <Header colSpan='100' content='Building 03' />
            </Table.Row>
            <Table.Row>
                {['Apt#', '01', '03', '05', '07', '09', '11', '15', '17', '19', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['', 'Gate', '', '', '', 'Fountain', '', '', '', 'Courtyard', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Type', '3/2 E', '2/2  D', '2/2  B', '2/2  B', '2/2  B', '2/2  B', '2/2  B', '1/1  A', '2/1 C', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Sq Ft', '1426', '1287', '1085', '1085', '1085', '1085', '1085', '845', '995', ''].map(content => <Header content={content} />)}
            </Table.Row>

        </Table.Header>

        <Table.Body>
            {/* 8th and 7th floor */}
            {range(9, 7, -1)
                .map(n => n.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                }))
                .map(floor => (
                    <Table.Row key={floor}>
                        <Table.Cell content={floor} textAlign='center' />
                        {['01', '03', '05', '07', '09', '11', '15', '17', '19'].map(unit => (
                            <Table.Cell style={{ backgroundColor: colors[data[`02-${floor}${unit}`].status] }} content={renderPrice(data[`02-${floor}${unit}`], matrixType)} textAlign='center'/>
                        ))}
                    </Table.Row>
                ))
            }
            <Table.Row>
                {['Apt#', '01', '03', '05', '07', '09', '11', '15', '17', '19', '21'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Type', '2/2 C', '1/1 A', '1/1 A', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '1/1 A', '2/1 C'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Sq Ft', '1014', '845', '845', '1085', '1085', '1085', '1085', '1085', '845', '995'].map(content => <Header content={content} />)}
            </Table.Row>

            {range(7, 0, -1)
                .map(n => n.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                }))
                .map(floor => (
                    <Table.Row key={floor}>
                        <Table.Cell content={floor} textAlign='center' />
                        {['01', '03', '05', '07', '09', '11', '15', '17', '19', '21'].map(unit => (
                            <Table.Cell style={{ backgroundColor: colors[data[`02-${floor}${unit}`].status] }} content={renderPrice(data[`02-${floor}${unit}`], matrixType)} textAlign='center'/>
                        ))}
                    </Table.Row>
                ))
            }

        </Table.Body>
    </Table>
);

const Table6 = ({ data, matrixType }) => (
    <Table celled compact>
        <Table.Header>
            <Table.Row>
                <Header colSpan='100' content='West / Parking Lot View' />
            </Table.Row>
            <Table.Row>
                {['Apt#', '02', '04', '06', '08', '10', '12', '14', '16', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['', '7th str', '', '', 'Parking', '', '', '', 'Parking', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Type', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 D', '3/2 E', ''].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Sq Ft', '1085', '1085', '1085', '1085', '1085', '1085', '1287', '1426', ''].map(content => <Header content={content} />)}
            </Table.Row>

        </Table.Header>

        <Table.Body>
            {/* 8th and 7th floor */}
            {range(9, 7, -1)
                .map(n => n.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                }))
                .map(floor => (
                    <Table.Row key={floor}>
                        <Table.Cell content={floor} textAlign='center' />
                        {['02', '04', '06', '08', '10', '12', '14', '16'].map(unit => (
                            <Table.Cell style={{ backgroundColor: colors[data[`03-${floor}${unit}`].status] }} content={renderPrice(data[`03-${floor}${unit}`], matrixType)} textAlign='center'/>
                        ))}
                    </Table.Row>
                ))
            }
            <Table.Row>
                {['Apt#', '02', '04', '06', '08', '10', '12', '14', '16', '18'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Type', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '2/2 B', '1/1 A', '1/1 A', '2/2 C'].map(content => <Header content={content} />)}
            </Table.Row>
            <Table.Row>
                {['Sq Ft', '1085', '1085', '1085', '1085', '1085', '1085', '845', '845', '1014'].map(content => <Header content={content} />)}
            </Table.Row>

            {range(7, 0, -1)
                .map(n => n.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                }))
                .map(floor => (
                    <Table.Row key={floor}>
                        <Table.Cell content={floor} textAlign='center' />
                        {['02', '04', '06', '08', '10', '12', '14', '16', '18'].map(unit => (
                            <Table.Cell style={{ backgroundColor: colors[data[`03-${floor}${unit}`].status] }} content={renderPrice(data[`03-${floor}${unit}`], matrixType)} textAlign='center'/>
                        ))}
                    </Table.Row>
                ))
            }

        </Table.Body>
    </Table>
);

const RoyalPalms = props => {

    const { data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div ref={ref} style={styles.root} className='print landscape'>

            <div>
                <Trigger />
            </div>
            <Title data={Object.values(filterObject(data, '01-'))} title='Royal Palms Apartments'/>
            <PrintDate isForPDF={false}/>
            <Table1 data={data} matrixType={matrixType} />
            <Table2 data={data} matrixType={matrixType} />
            <div className='pagebreak' />
            <div className='printspace' />
            <Title data={Object.values(filterObject(data, '02-'))} title='Royal Palms Apartments'/>
            <PrintDate isForPDF={false}/>
            <div className='print-font-small'>
                <Table3 data={data} matrixType={matrixType} />
                <Table4 data={data} matrixType={matrixType} />
            </div>
            <div className='pagebreak' />
            <div className='printspace' />
            <Title data={Object.values(filterObject(data, '02-'))} title='Royal Palms Apartments'/>
            <PrintDate isForPDF={false}/>
            <div className='print-font-small'>
                <Table5 data={data} matrixType={matrixType} />
                <Table6 data={data} matrixType={matrixType} />
            </div>

        </div>
    );
};

export default RoyalPalms;
